export default __webpack_public_path__ + "static/media/SCI-COURSE.08ee160b.jpg";